export default {
  data: () => ({

    rawData:  [],
    
    circle: null,
    title: null,
    summary: null,
    columns: null,
    keys: null,
    filters: null,
    
    drawY: 0,
    angle: null,
    canvasForms:  null,
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {
    set_ColorStyles() {
      this.gmx_ColorH2Sets()
    },
  }

}